module.exports = __webpack_public_path__ + "e614236c69819dafd44110a4429df949.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_star.png
// module id = 8
// module chunks = 0 1 2 3 4